'use client';

import { c as _c } from "react/compiler-runtime";
import Box from '@classify/react-core-components/Box';
import Stack from '@classify/react-core-components/Stack';
import { alpha } from '@classify/react-core-components/styles';
import InvertedCIcon from '../images/InvertedCIcon';
import HeroVideo from './HeroVideo';
import HeroImage from './HeroImage';
const THUMBNAIL_SIZES = {
  default: 188,
  sm: 286,
  md: 250,
  lg: 388
};
type Props = {
  course: {
    teaserUrl?: string;
    title?: string;
    illustration?: string;
    categoryColor?: string;
  };
};
export default function HeroAsset(t0) {
  const $ = _c(17);
  const {
    course
  } = t0;
  const {
    teaserUrl: t1,
    title: t2,
    illustration: t3,
    categoryColor
  } = course;
  const teaserUrl = t1 === undefined ? "" : t1;
  const title = t2 === undefined ? "" : t2;
  const illustration = t3 === undefined ? "" : t3;
  const t4 = categoryColor || "#000";
  let t5;
  if ($[0] !== t4) {
    t5 = alpha(t4, 0.16);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const iconBackgroundColor = t5;
  let t6;
  if ($[2] !== teaserUrl) {
    t6 = teaserUrl?.match(/\/(\d+)/) || [];
    $[2] = teaserUrl;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const [, videoId] = t6;
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      xs: "center",
      sm: "flex-end"
    };
    t8 = {
      mb: {
        xs: 3,
        sm: 0
      }
    };
    $[4] = t7;
    $[5] = t8;
  } else {
    t7 = $[4];
    t8 = $[5];
  }
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      mr: {
        xs: `-${THUMBNAIL_SIZES.default / 3}px`,
        sm: `-${THUMBNAIL_SIZES.sm / 3}px`,
        md: `-${THUMBNAIL_SIZES.md / 3}px`,
        lg: `-${THUMBNAIL_SIZES.lg / 3}px`
      },
      "& svg": {
        height: {
          xs: THUMBNAIL_SIZES.default,
          sm: THUMBNAIL_SIZES.sm,
          md: THUMBNAIL_SIZES.md,
          lg: THUMBNAIL_SIZES.lg
        }
      }
    };
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== iconBackgroundColor) {
    t10 = <Box sx={t9} aria-hidden={true}><InvertedCIcon fill={iconBackgroundColor} /></Box>;
    $[7] = iconBackgroundColor;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== illustration || $[10] !== teaserUrl || $[11] !== title || $[12] !== videoId) {
    t11 = <Box>{teaserUrl ? <HeroVideo title={title} fallbackImgUrl={illustration} videoId={Number(videoId)} /> : <HeroImage src={illustration} />}</Box>;
    $[9] = illustration;
    $[10] = teaserUrl;
    $[11] = title;
    $[12] = videoId;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11) {
    t12 = <Stack direction="row" justifyContent={t7} sx={t8}>{t10}{t11}</Stack>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}